import styled, {css} from 'styled-components';

import BaseClockIcon from '@edna/icons/clock.svg';

import {InputPicker} from '../InputPicker';
import {NumberInput as BaseNumberInput} from '../NumberInput';
import {mixins} from '../styles';
import {DEFAULT_WIDTH, TTimePickerProps} from './types';

type TClockIconProps = {
  disabled: boolean;
};

export const ClockIcon = styled(BaseClockIcon)<TClockIconProps>`
  ${mixins.wh('16px')}
  ${({theme, disabled}) =>
    disabled &&
    css`
      color: ${theme.palette.grey400};
    `}
`;

export const TimePicker = styled(InputPicker)<TTimePickerProps>`
  width: ${DEFAULT_WIDTH};
  min-width: ${DEFAULT_WIDTH};
`;

export const NumberInput = styled(BaseNumberInput)``;
